export default __webpack_public_path__ + "static/media/rack_stack.15f38511.jpg";